import { useEffect, useState } from "react";

// Jds
import {
  Button,
  Container,
  Text,
  Icon,
  InputField,
  InputDropdown,
  InputPhoneDropdown,
  Tooltip,
  Notifications,
  Table,
} from "@jds/core";

//Local
import classes from "./PlansContainer.module.css";
import useApiHttp from "../../../hooks/use-http";
import PageLoader from "../Loader/PageLoader";
import Loader from "../Loader/Loader";
import useInput from "../../../hooks/use-input";
import {
  validateEmail,
  validateGSTIN,
  validatePhoneNumber,
  validateTextInput,
} from "../../../util/validation";
import EmptyState from "../../NoData/EmptyState";
import { useSelector } from "react-redux";
import JdsModal from "../JdsModal";
import { Box, FormControlLabel, Switch } from "@mui/material";

const PlansContainer = ({ setPlansModalHead = () => { } }) => {
  const { subscriptionPlan } = useSelector((state) => state.plans);
  const { sendRequest: planRequest, isLoading: isPlansGetting } = useApiHttp();
  const { sendRequest: customerDetail, isLoading: isCustomerDetailGetting } =
    useApiHttp();
  const [selectedAcc, setSelectedAcc] = useState(null);
  const [plans, setPlans] = useState([]);
  const [choosePlan, setChoosePlan] = useState({});
  const [registerUser, setRegisterUser] = useState(false);
  const [userDetail, setUserDetail] = useState({});
  const [autoRenew, setAutoRenew] = useState(false);

  const toggleItem = (index) => {
    if (index == selectedAcc) {
      setSelectedAcc(null);
    } else {
      setSelectedAcc(index);
    }
  };
  useEffect(() => {
    planRequest(
      {
        // url: `chargeit/storage/plans`,
        url: subscriptionPlan
          ? `chargeit/storage/plans`
          : `chargeit/storage/upgrade-plans`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        console.log("plan123" + data);

        // setPlans(data?.data);
        setPlans(data?.data?.upgradePlans || data?.data);
      },
      (err, data) => {
        console.log("plan request err", data);
      }
    );
    customerDetail(
      {
        url: `chargeit/register/customer`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setUserDetail(data);
        setRegisterUser(true);
      },
      (err, data) => {
        console.log("user check 123");
        if (data?.statusCode == 404) {
          setRegisterUser(false);
        }
      }
    );
  }, []);
  return (
    <>
      {isPlansGetting ? (
        <Loader />
      ) : !choosePlan?.planId ? (
        plans?.length > 0 ? (
          plans.map((item, index) => (
            <PlanAccordion
              toggleItem={() => toggleItem(index)}
              show={index == selectedAcc ? true : false}
              data={item}
              setChoosePlan={setChoosePlan}
              setPlansModalHead={setPlansModalHead}
              lastIndex={index === plans?.length - 1}
            />
          ))
        ) : (
          <EmptyState
            title="Contact admin for further details."
            action={false}
          />
        )
      ) : (
        <CustomerRegister
          choosePlan={choosePlan}
          data={userDetail}
          registerUser={registerUser}
          setChoosePlan={setChoosePlan}
          setPlansModalHead={setPlansModalHead}
          setRegisterUser={setRegisterUser}
        />
      )}
    </>
  );
};

export default PlansContainer;

const PlanAccordion = ({
  show,
  toggleItem,
  data,
  setChoosePlan,
  setPlansModalHead,
  lastIndex,
}) => {
  return (
    <div className={classes["acc-container"]}>
      {/* title */}
      <div
        onClick={toggleItem}
        style={{
          borderBottom: lastIndex || show ? "none" : "1px solid #e0e0e0",
          padding: "20px 0px",
          cursor: "pointer",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Text text={`${data?.name}`} appearance="body-m-bold" />
          <Button
            kind="tertiary"
            icon={show ? "IcMinus" : "IcAdd"}
            onClick={toggleItem}
          />
        </div>
      </div>
      {/* plans */}

      <div
        className={show ? `${classes.contentShow}` : `${classes.contentHide}`}
      >
        <Container style={{ flexWrap: "wrap" }} gap={12}>
          {data?.prices?.map((item) => (
            <Container
              style={{
                width: "230px",
                padding: "16px",
                borderRadius: "24px",
                border: "1px solid #e0e0e0",
              }}
              direction="column"
            >
              <Text
                text={`${item?.currencySymbol} ${item?.fixedPrice}`}
                appearance="body-l-bold"
              />
              {/* <Container fullWidth>
                  <span
                    onClick={() => {}}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {" "}
                    <Text
                      text={`More Info`}
                      appearance="body-xs-bold"
                      color="primary-60"
                      as="span"
                    />
                  </span>
                </Container> */}

              <Container
                direction="row"
                style={{
                  borderTop: "1px solid #e0e0e0",
                  paddingBlock: "12px",
                  // marginTop: "px",
                }}
                fullWidth
                gap={16}
              >
                <Container fullWidth direction="column" gap={1}>
                  <Text
                    text={"VALIDITY"}
                    color="primary_grey_80"
                    appearance="body-xs-bold"
                  />
                  <Text
                    text={`${item?.billingFrequency?.value || 1} ${item?.billingFrequency?.period || "months"
                      }`}
                    appearance="body-xs-bold"
                  />
                </Container>
              </Container>
              <Container fullWidth horizontalAlign="center">
                <Button
                  fullWidth
                  label="Choose Plan"
                  size="small"
                  onClick={() => {
                    setChoosePlan({
                      planId: data?.planId,
                      billingFrequency: item?.billingFrequency?.name,
                      // name: data?.name,
                    });
                    setPlansModalHead(data?.name);
                  }}
                />
              </Container>
            </Container>
          ))}
        </Container>
      </div>
    </div>
  );
};

const CustomerRegister = ({
  choosePlan,
  data,
  registerUser,
  setChoosePlan,
  setPlansModalHead,
  setRegisterUser = () => { },
}) => {
  const [stateSelectedIndex, setStateSelectedIndex] = useState(null);
  const [errorAlertCls, setErrorAlertCls] = useState(true);
  const [errorAlertMsg, setErrorAlertMsg] = useState("");
  const [isGstFieldOpen, setGstFieldOpen] = useState(false);
  const [gstDetails, setGstDetails] = useState()

  const { sendRequest: registerUserReq, isLoading: userRegistering } =
    useApiHttp();
  const { sendRequest: updateUserReq, isLoading: userUpdating } = useApiHttp();

  const { sendRequest: razorpayReq, isLoading: isRazorpayReq } = useApiHttp();
  const { sendRequest: getGstDetails, isLoading: isGstDetailsLoading } = useApiHttp();
  const { subscriptionPlan } = useSelector((state) => state.plans);

  const {
    value: firstName,
    isValid: isValidFirstName,
    hasError: firstNameError,
    valueChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstName,
  } = useInput(validateTextInput, {
    type: "text",
    value: data?.firstName,
  });

  const {
    value: lastName,
    isValid: isValidLastName,
    hasError: lastNameError,
    valueChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetLastName,
  } = useInput(validateTextInput, {
    type: "text",
    value: data?.lastName,
  });
  const {
    value: phoneNumber,
    isValid: isValidPhoneNumber,
    hasError: phoneNumberError,
    valueChangeHandler: phoneNumberChangeHandler,
    inputBlurHandler: phoneNumberBlurHandler,
    reset: resetPhoneNumber,
  } = useInput(validatePhoneNumber, {
    type: "text",
    value:
      data?.phoneNumber?.length > 10
        ? data?.phoneNumber?.slice(3)
        : data?.phoneNumber || "",
  });

  const {
    value: emailAddress,
    isValid: isValidEmailAddress,
    hasError: emailAddressError,
    valueChangeHandler: emailAddressChangeHandler,
    inputBlurHandler: emailAddressBlurHandler,
    reset: resetEmailAddress,
  } = useInput(validateEmail, {
    type: "text",
    value: data?.email || "",
  });

  const {
    value: address,
    isValid: isValidAddress,
    hasError: addressError,
    valueChangeHandler: addressChangeHandler,
    inputBlurHandler: addressBlurHandler,
    reset: resetAddress,
  } = useInput(validateTextInput, {
    type: "text",
    value: data?.address,
  });

  const {
    value: city,
    isValid: isValidCity,
    hasError: cityError,
    valueChangeHandler: cityChangeHandler,
    inputBlurHandler: cityBlurHandler,
    reset: cityReset,
  } = useInput(validateTextInput, {
    type: "text",
    value: data?.city,
  });

  const {
    value: state,
    isValid: isValidState,
    hasError: stateError,
    valueChangeHandler: stateChangeHandler,
    inputBlurHandler: stateBlurHandler,
    reset: stateReset,
  } = useInput(validateTextInput, {
    type: "text",
    value: data?.state,
  });

  const {
    value: pincode,
    isValid: isValidPincode,
    hasError: pincodeError,
    valueChangeHandler: pincodeChangeHandler,
    inputBlurHandler: pincodeBlurHandler,
    reset: resetPincode,
  } = useInput(
    (number) => {
      // Trim any leading or trailing whitespace from the input
      const trimmedNumber = number?.trim();

      // Regular expression to match a 6-digit phone number with optional country code
      const phoneNumPattern = /^(?:\+91|0{0,2}91)?[\s-]?(\d{6})$/;

      // Test the trimmed number against the pattern
      return phoneNumPattern?.test(trimmedNumber);
    },
    {
      type: "text",
      value: data?.pinCode || "",
    }
  );

  const {
    value: gstNumber,
    isValid: isGstNumberValid,
    hasError: gstNumberHasError,
    valueChangeHandler: gstNumberChangeHandler,
    inputBlurHandler: gstNumberBlurHandler,
    reset: resetGstNumber,
  } = useInput(validateGSTIN, {
    // type: "text",
    // value: data?.firstName,
  });


  const stateList = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman And Nicobar Islands",
    "Chandigarh",
    "Dadra And Nagar Haveli And Daman And Diu",
    "Lakshadweep",
    "Delhi",
    "Puducherry",
    "Ladakh",
    "Jammu And Kashmir",
  ];

  const isValidForm =
    !isValidFirstName ||
    !isValidLastName ||
    !isValidPhoneNumber ||
    !isValidEmailAddress ||
    !isValidAddress ||
    !isValidCity ||
    !isValidState ||
    !isValidPincode;
  const handleSubmit = () => {
    const formData = {
      firstName: firstName,
      lastName: lastName,
      phoneNo: "+91" + phoneNumber,
      emailId: emailAddress,
      address: address,
      city: city,
      state: state,
      pinCode: pincode,
      country: "IN",
    };
    if (!registerUser) {
      registerUserReq(
        {
          url: `chargeit/register/customer`,
          method: "POST",
          base: "MEDIA",
          body: formData,
        },
        null,
        (data) => {
          handleRazorpay();
          setRegisterUser(true);
        },
        (err, data) => {
          console.log("register error123");
          if (data?.statusCode === 400) {
            setErrorAlertCls(false);
            setErrorAlertMsg(data?.errors?.message || data?.message);
          }
          if (data?.statusCode === 500) {
            Notifications.toast.error({
              id: "register-user-error",
              title: "Something went wrong!",
            });
          }
        }
      );
    }
    if (registerUser) {
      updateUserReq(
        {
          url: `chargeit/register/customer`,
          method: "PUT",
          base: "MEDIA",
          body: formData,
        },
        null,
        (data) => {
          handleRazorpay();
        },
        (err, data) => {
          console.log("Update user error123", data);
          if (data?.statusCode === 400) {
            setErrorAlertCls(false);
            setErrorAlertMsg(data?.errors?.message || data?.message);
          }
          if (data?.statusCode === 500) {
            Notifications.toast.error({
              id: "register-user-error",
              title: "Something went wrong!",
            });
          }
        }
      );
    }
  };
  const handleRazorpay = () => {
    let body = subscriptionPlan
      ? {
        planId: choosePlan.planId,
        billingFrequency: choosePlan.billingFrequency,
        autoRenew: false,
      }
      : {
        planId: choosePlan.planId,
        autoRenew: false,
      };
    razorpayReq(
      {
        url: subscriptionPlan
          ? `chargeit/subscription`
          : `chargeit/storage/change-plan`,
        method: "POST",
        base: "MEDIA",
        body: body,
      },
      null,
      (data) => {
        localStorage.redirectUrl = window.location.href;
        const url = data?.paymentUrl;
        window.location.href = url;
        // window.open(url, "_blank");
      },
      (err, data) => {
        console.log("razorpay error123", data);
        if (data?.statusCode === 400) {
          setErrorAlertCls(false);
          setErrorAlertMsg(data?.errors?.message || data?.message);
        }
        if (data?.statusCode === 500) {
          Notifications.toast.error({
            id: "subscription-error",
            title: "Something went wrong!",
          });
        }
      }
    );
  };

  const getGstDetailsHandler = () => {
    getGstDetails({
      url: `chargeit/get-gst-details/${gstNumber}`,
      base: 'MEDIA'
    }, null,
      (data) => {
        data && setGstDetails(data?.data)
      },
      (_, data) => {
        Notifications.toast.error(data?.message || data?.error)
      }
    )
  }

  useEffect(() => {
    if (data?.state) {
      const selectIndex = stateList.indexOf(data?.state);
      setStateSelectedIndex(selectIndex);
    }
  }, []);
  return (
    <>
      <Container fullWidth style={{ marginBottom: "20px" }}>
        <Icon
          ic={"IcArrowBack"}
          onClick={() => {
            setChoosePlan({});
            setPlansModalHead("Plans");
          }}
        />
      </Container>
      <Box mb={3}>
        <Container fullWidth style={{ marginBottom: '6px' }} verticalAlign="center">
          <Text text={`GST Information:`} appearance="body-m-bold" />
        </Container>
        <Container fullWidth horizontalAlign="space-between" verticalAlign="center">
          <Text text={`Do you have GSTIN?`} appearance="body-s" />
          <FormControlLabel
            // checked={isAutoApproval}
            control={<Switch />}
            label={<Text text="" color="primary_grey_80" />}
            labelPlacement="start"
            onChange={() => setGstFieldOpen(pre => !pre)}
          />
        </Container>
        {isGstFieldOpen &&
          <>
            <Container fullWidth gap={16}>
              <InputField
                label="GSTIN"
                value={gstNumber}
                placeholder="Enter you GSTIN"
                name="gst number"
                onChange={gstNumberChangeHandler}
                onBlur={gstNumberBlurHandler}
                state={gstNumberHasError ? "error" : ""}
                stateText="Please enter valid GSTIN!"
              />
              <Box sx={{ width: '60px', cursor: 'pointer', marginTop: '38px', opacity: isGstNumberValid || isGstDetailsLoading ? 1 : 0.3 }}
                onClick={() => { isGstNumberValid && getGstDetailsHandler() }}
              >
                {isGstDetailsLoading ? <Loader size="small" /> : <Text text="Submit" color="primary-60" />}
              </Box>
            </Container>

            {gstDetails &&
              <Box my={2} p={2} sx={{ border: '1px solid var(--color-primary-grey-60)', borderRadius: '12px' }}>
                <table className={classes["gst__details"]}>
                  <tbody>
                    <tr>
                      <td>
                        <Text text="GSTIN" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td className={classes["gst__details-info"]} >
                        <Text text={gstDetails?.gstinNumber || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Text text="Organisation name" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td className={classes["gst__details-info"]}>
                        <Text text={gstDetails?.organizationName || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Text text="Address" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text={gstDetails?.address || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Text text="Additional address info" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text={gstDetails?.additionalAddressInfo || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Text text="Pincode" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text={gstDetails?.pincode || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Text text="State" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text={gstDetails?.state || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Text text="City" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text={gstDetails?.city || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Text text="District" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text={gstDetails?.district || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Text text="Country" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text={gstDetails?.country || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Text text="Taxpayer type" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text=":" appearance="body-s-bold" />
                      </td>
                      <td>
                        <Text text={gstDetails?.taxpayerType || "-"} appearance="body-s" color="primary-grey-80" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Box>
            }
          </>
        }
      </Box>
      <Container fullWidth style={{ marginBottom: '12px' }}>
        <Text text={`Billing Address:`} appearance="body-m-bold" />
      </Container>
      <div className="column-form full-width">
        <InputField
          label="First Name *"
          value={firstName}
          name="firstName"
          onChange={firstNameChangeHandler}
          onBlur={firstNameBlurHandler}
          state={firstNameError ? "error" : ""}
          stateText="first name is invalid"
        />

        <InputField
          label="Last Name *"
          value={lastName}
          name="lastName"
          state={lastNameError ? "error" : ""}
          stateText="last name is invalid"
          onChange={lastNameChangeHandler}
          onBlur={lastNameBlurHandler}
        />

        <InputField
          label="Phone Number *"
          value={phoneNumber}
          name="phoneNumber"
          onChange={phoneNumberChangeHandler}
          onBlur={phoneNumberBlurHandler}
          state={phoneNumberError ? "error" : ""}
          stateText="phone number is invalid"
          type="number"
          prefix={
            <InputPhoneDropdown
              selectedIndex={0}
              items={[
                {
                  label: "+91",
                  prefix: <Icon ic={"IcAdd"} />,
                  value: "+91",
                },
                {
                  label: "+88",
                  prefix: <Icon ic={"IcAdd"} />,
                  value: "+88",
                },
                {
                  label: "+78",
                  prefix: <Icon ic={"IcAdd"} />,
                  value: "+78",
                },
              ]}
              onSelect={(idx) => {
                // action("country code selected index:")(idx);
              }}
              disabled
            />
          }
        />

        <InputField
          label="Email *"
          value={emailAddress}
          name="emailAddress"
          onChange={emailAddressChangeHandler}
          onBlur={emailAddressBlurHandler}
          state={emailAddressError ? "error" : ""}
          stateText="email address is invalid"
        />

        <InputField
          label="Address *"
          value={address}
          name="address"
          onChange={addressChangeHandler}
          onBlur={addressBlurHandler}
          state={addressError ? "error" : ""}
          stateText="address is invalid"
        />

        <InputField
          label="City *"
          value={city}
          name="city"
          onChange={cityChangeHandler}
          onBlur={cityBlurHandler}
          state={cityError ? "error" : ""}
          stateText="city is invalid"
        />

        <InputDropdown
          label="State *"
          items={stateList?.map((item) => {
            return {
              label: item,
              value: item,
            };
          })}
          onSelect={(index, value) => {
            stateChangeHandler({ target: { value: value } });
          }}
          // onClose={stateBlurHandler}
          state={stateError ? "error" : "none"}
          stateConfig={{ errorText: "Please select the event type" }}
          selectedIndex={stateSelectedIndex}
        />

        <InputField
          label="Pincode *"
          value={pincode}
          name="pincode"
          onChange={pincodeChangeHandler}
          onBlur={pincodeBlurHandler}
          state={pincodeError ? "error" : ""}
          stateText="pincode is invalid"
          type="number"
        />
        <Container fullWidth horizontalAlign="center">
          <Button
            disabled={
              isValidForm || userRegistering || userUpdating || isRazorpayReq
            }
            type="submit"
            label="Submit"
            size="large"
            onClick={handleSubmit}
          />
        </Container>
      </div>
      <JdsModal
        header=""
        kind="informational"
        close={errorAlertCls}
        onClose={() => {
          setErrorAlertCls(true);
        }}
        size="m"
      >
        {!errorAlertCls && (
          <>
            <Container
              style={{ alignItems: "center", width: "100%" }}
              fullWidth
              gap={16}
              direction="column"
            >
              <Icon ic={"IcAlert"} kind="background" size="xxl" />

              <p
                style={{
                  color: "var(--color-primary-grey-80)",
                  fontSize: "18px",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                {errorAlertMsg ||
                  "Please check other plans for more options and pricing details."}
              </p>
            </Container>
          </>
        )}
      </JdsModal>
    </>
  );
};
